<template>
  <v-login title="Activation">
    <form
      action
      @submit.prevent="submit"
    >
      <v-fieldset
        id="username"
        v-model="username"
        text="User Name"
        type="email"
        is-required
      />
      <v-fieldset
        id="new"
        v-model="newPassword"
        text="New password"
        placeholder="Must have at least 6 characters"
        :help-text="newPasswordHelper"
        type="password"
        pattern="^\S{6,}"
        is-required
        is-revealable
      />
      <v-fieldset
        id="confirm"
        v-model="checkPassword"
        :help-text="confirmHelper"
        text="Confirm new password"
        type="password"
        pattern="^\S{6,}"
        is-required
        is-revealable
      />

      <v-button
        class="mt-auto"
        is-submit
        size="lg"
        is-block
      >
        Activate
      </v-button>
    </form>
  </v-login>
</template>
<script>
  import Login from "@/templates/Login";
  import Button from "@/atoms/Button";
  import Fieldset from "@/molecules/Fieldset";
  import {UPDATE_PASSWORD} from "@/store/actions.type";

  export default {
    name: "Activation",
    components: {
      'v-button': Button,
      'v-fieldset': Fieldset,
      'v-login': Login,

    },
    data() {
      return {
        username: '',
        newPassword: '',
        checkPassword: '',
        checkWithSpaceHelper: '',
        notSamePasswordHelper: '',
        checkMinInputHelper: '',
      }
    },
    computed: {
      checkMinInput() {
        return this.newPassword.length >= 6
      },
      newPasswordHelper() {
        return this.checkWithSpaceHelper + this.checkMinInputHelper;
      },
      confirmHelper() {
        return this.notSamePasswordHelper + this.checkWithSpaceHelper + this.checkMinInputHelper;
      },
      //  confirmed password should be the same as new password
      notSamePassword() {
        if (this.newPassword !== '' && this.checkPassword !== '') {
          return (this.newPassword !== this.checkPassword);
        } else {
          return false;
        }
      },
      checkWithSpace() {
        if (/\s/.test(this.newPassword)) {
          return true;
        } else {
          return false;
        }
      },
      passwordsFilled() {
        return (this.oldPassword !== '' && this.newPassword !== '' && this.checkPassword !== '')
      }
    },
    watch: {
      checkWithSpace(check) {
        (check ? this.checkWithSpaceHelper = 'Space character is not allowed for new password. ' : this.checkWithSpaceHelper = '')
      },
      checkMinInput(check) {
        (check ? this.checkMinInputHelper = '' : this.checkMinInputHelper = 'New password requires at least 6 characters. ')
      },
      notSamePassword(check) {
        (check ? this.notSamePasswordHelper = 'Password does not match. ' : this.notSamePasswordHelper = '')
      }
    },
    methods: {
      submit: function () {

      }
    }
  }
</script>
